/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Merge_By_Speakers_SuccessInputs */



/**
* | output |
* | --- |
* | "Events merged by speakers successfully" |
*
* @param {Event_Group_Options_Merge_By_Speakers_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_by_speakers_success = /** @type {((inputs?: Event_Group_Options_Merge_By_Speakers_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_By_Speakers_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements fusionnés par locuteurs avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die von den Rednern zusammengeführten Veranstaltungen wurden erfolgreich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi uniti con successo dagli oratori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выступления докладчиков успешно объединили различные события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos fusionados por oradores exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演讲者成功合并了活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("講演者によるイベントの統合に成功しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं द्वारा सफलतापूर्वक विलय किए गए कार्यक्रम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos unificados pelos palestrantes com sucesso")
	return /** @type {LocalizedString} */ ("Events merged by speakers successfully")
});